module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-packet-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('EditPacketReveal', {
    attrs: {
      "item": _vm.item
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23688f2d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/PacketButtons.vue
// module id = 2336
// module chunks = 1